<style scoped lang="scss" type="text/scss">

</style>

<template>
    <el-select class="full-width" clearable multiple :multiple-limit="multipleLimit"
               v-model="valueSync" filterable :placeholder="placeholder"
    >
        <el-option
                v-for="item in options"
                :key="item.personal_id"
                :label="item.personal_name"
                :value="item.personal_id">
            <span style="float: left">{{ item.personal_name }}</span>
            <span style="float: right; color: #8492a6; font-size: 13px; margin-right: 1.5rem;">{{ item.type_text }}</span>
        </el-option>
    </el-select>
</template>

<script>
    import {handlePlayerMembers} from '../../../utils/data-handler';

    export default {
        name: '',
        props: {
            value: Array,
            placeholder: String,
            multipleLimit: Number
        },
        computed: {
            // 不在该组件中对 currentCompetitionId 进行监听，以免重复请求过多
            currentManagedPlayerId () {
                return this.$store.state.player.currentManagedPlayerId;
            },
            options () {
                return handlePlayerMembers(this.$store.state.player.currentManagedPlayerMembers);
            }
        },
        data () {
            return {
                valueSync: []
            };
        },
        watch: {
            value (value) {
                this.valueSync = value;
            },
            valueSync (valueSync) {
                if (valueSync === '' || valueSync === null) {
                    this.valueSync = [];
                    return;
                }
                this.$emit('input', valueSync);
            }
        }
    };
</script>
